import { getUrlParam } from "./urlParamsUtil";

/** A preview switch for unreleased UI. Visiting with ?<param>=true turns it on
 * for the rest of the browser session and ?<param>=false turns it off. Call at
 * module load; returns whether the preview is on. */
export const sessionPreview = (
  param: string,
  storageKey: string,
): (() => boolean) => {
  try {
    const value = getUrlParam(param);
    if (value === "true") {
      sessionStorage.setItem(storageKey, "true");
    } else if (value === "false") {
      sessionStorage.removeItem(storageKey);
    }
  } catch {
    // Privacy modes throw; the preview just won't stick.
  }

  return () => {
    try {
      return sessionStorage.getItem(storageKey) === "true";
    } catch {
      return false;
    }
  };
};
